import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    class: "sc-page-header"
};
const _hoisted_2 = {
    key: 0,
    class: "sc-page-header__icon"
};
const _hoisted_3 = {
    class: "sc-page-header__title"
};
const _hoisted_4 = {
    key: 0
};
const _hoisted_5 = {
    key: 1,
    class: "sc-page-header__main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_icon = _resolveComponent("el-icon");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        $props.icon ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", null, [
                _createVNode(_component_el_icon, null, {
                    default: _withCtx(()=>[
                            (_openBlock(), _createBlock(_resolveDynamicComponent($props.icon)))
                        ]),
                    _: 1
                })
            ])
        ])) : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString($props.title), 1),
            $props.description || _ctx.$slots.default ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default", {}, ()=>[
                        _createTextVNode(_toDisplayString($props.description), 1)
                    ], true)
            ])) : _createCommentVNode("", true)
        ]),
        _ctx.$slots.main ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "main", {}, undefined, true)
        ])) : _createCommentVNode("", true)
    ]);
}
